export default "__VITE_ASSET__CW8ZrrCH__"